// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* INCYIA Gantt — full-bleed timeline */

.incyia-gantt-wrap {
  font-family: Lato, sans-serif;
  width: 100%;
  max-width: 100%;
  display: block;
  box-sizing: border-box;
}

.incyia-gantt-toolbar {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
  flex-wrap: wrap;
  width: 100%;
}

.incyia-gantt-title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #0b1e2d;
  line-height: 1.25;
}

.incyia-gantt-hint {
  margin: 4px 0 0;
  font-size: 13.5px;
  color: #5f7484;
  line-height: 1.4;
}

.incyia-gantt-chips {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.incyia-gantt-chip {
  display: inline-flex;
  align-items: center;
  height: 34px;
  padding: 0 16px;
  border-radius: 8px;
  border: 1px solid #dee4f0;
  background: #fff;
  font-family: inherit;
  font-size: 13px;
  color: #5f7484;
  cursor: pointer;
  transition: background 0.14s, border-color 0.14s, color 0.14s;
  width: fit-content !important;
}

.incyia-gantt-chip:hover {
  border-color: #8b99b4;
  color: #0b1e2d;
}

.incyia-gantt-chip.is-on {
  background: #e2f7f2;
  border-color: transparent;
  color: #0e8271;
  font-weight: 600;
}

.incyia-gantt {
  width: 100%;
  border: 1px solid #dee4f0;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  box-shadow:
    0 1px 2px rgba(15, 23, 42, 0.05),
    0 10px 28px -20px rgba(0, 20, 109, 0.4);
  box-sizing: border-box;
}

.incyia-gantt-scroll {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
}

.incyia-gantt-inner {
  display: block;
  width: 100%;
  min-width: 100%;
  box-sizing: border-box;
}

.incyia-gantt-row {
  display: flex;
  width: 100%;
  min-width: 100%;
  border-bottom: 1px solid #eaeff7;
  box-sizing: border-box;
}

.incyia-gantt-row:last-child {
  border-bottom: none;
}

.incyia-gantt-left {
  width: 280px;
  flex: 0 0 280px;
  padding: 16px 18px;
  border-right: 1px solid #dee4f0;
  position: sticky;
  left: 0;
  background: #fff;
  z-index: 2;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 56px;
}

.incyia-gantt-row.is-head .incyia-gantt-left {
  background: #f7f9fd;
  min-height: 64px;
}

.incyia-gantt-left b {
  font-size: 14px;
  font-weight: 600;
  display: block;
  color: #0b1e2d;
}

.incyia-gantt-left span {
  font-family: 'IBM Plex Mono', ui-monospace, monospace;
  font-size: 11.5px;
  color: #5f7484;
  display: block;
  margin-top: 3px;
}

.incyia-gantt-track {
  position: relative;
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  width: auto;
}

.incyia-gantt-track.is-header {
  display: flex;
  flex-direction: column;
  background: #f7f9fd;
  min-width: 0;
}

.incyia-gantt-month {
  display: flex;
  width: 100%;
  flex: none;
}

.incyia-gantt-m {
  padding: 8px 10px;
  font-weight: 700;
  font-size: 11px;
  letter-spacing: 0.13em;
  text-transform: uppercase;
  color: #5f7484;
  border-right: 1px solid #dee4f0;
  background: #f7f9fd;
  flex: none;
  box-sizing: border-box;
  text-align: left;
}

.incyia-gantt-days {
  display: flex;
  width: 100%;
  flex: 1 1;
  min-height: 40px;
}

.incyia-gantt-day {
  flex: 1 0;
  min-width: 40px;
  border-right: 1px solid #eaeff7;
  text-align: center;
  padding: 8px 0;
  font-family: 'IBM Plex Mono', ui-monospace, monospace;
  font-size: 10px;
  color: #8b99b4;
  box-sizing: border-box;
}

.incyia-gantt-day.is-we {
  background: #f7f9fd;
}

.incyia-gantt-day.is-week {
  min-width: 64px;
}

.incyia-gantt-day b {
  display: block;
  font-size: 12px;
  color: #5f7484;
  font-weight: 600;
}

.incyia-gantt-bar {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 28px;
  border-radius: 7px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  font-size: 12.5px;
  color: #fff;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  background: linear-gradient(90deg, #00146d, #1f3e9e);
  box-shadow: 0 2px 8px -3px rgba(0, 20, 109, 0.6);
  -webkit-user-select: none;
          user-select: none;
  touch-action: none;
  box-sizing: border-box;
}

.incyia-gantt-bar.is-editable {
  cursor: grab;
  pointer-events: auto;
}

.incyia-gantt-bar.is-dragging {
  cursor: grabbing;
  opacity: 0.92;
  z-index: 3;
}

.incyia-gantt-bar-label {
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1;
  min-width: 0;
  pointer-events: none;
}

.incyia-gantt-handle {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 10px;
  cursor: ew-resize;
  z-index: 2;
}

.incyia-gantt-handle.is-start {
  left: 0;
}

.incyia-gantt-handle.is-end {
  right: 0;
}

.incyia-gantt-handle::after {
  content: '';
  position: absolute;
  top: 6px;
  bottom: 6px;
  width: 2px;
  border-radius: 1px;
  background: rgba(255, 255, 255, 0.55);
}

.incyia-gantt-handle.is-start::after {
  left: 4px;
}

.incyia-gantt-handle.is-end::after {
  right: 4px;
}

@media (max-width: 900px) {
  .incyia-gantt-left {
    width: 200px;
    flex-basis: 200px;
  }
}

@media (max-width: 760px) {
  .incyia-gantt-left {
    width: 160px;
    flex-basis: 160px;
    padding: 12px 12px;
  }

  .incyia-gantt-day {
    min-width: 32px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/IncyiaGantt.css"],"names":[],"mappings":"AAAA,uCAAuC;;AAEvC;EACE,6BAA6B;EAC7B,WAAW;EACX,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,eAAe;EACf,6DAA6D;EAC7D,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB;;2CAEyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,OAAO;EACP,gBAAgB;EAChB,UAAU;EACV,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,+BAA+B;EAC/B,mBAAmB;EACnB,UAAU;EACV,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,SAAW;EACX,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;EACd,qDAAqD;EACrD,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,oDAAoD;EACpD,gDAAgD;EAChD,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,SAAO;EACP,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* INCYIA Gantt — full-bleed timeline */\n\n.incyia-gantt-wrap {\n  font-family: Lato, sans-serif;\n  width: 100%;\n  max-width: 100%;\n  display: block;\n  box-sizing: border-box;\n}\n\n.incyia-gantt-toolbar {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 14px;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.incyia-gantt-title {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  color: #0b1e2d;\n  line-height: 1.25;\n}\n\n.incyia-gantt-hint {\n  margin: 4px 0 0;\n  font-size: 13.5px;\n  color: #5f7484;\n  line-height: 1.4;\n}\n\n.incyia-gantt-chips {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.incyia-gantt-chip {\n  display: inline-flex;\n  align-items: center;\n  height: 34px;\n  padding: 0 16px;\n  border-radius: 8px;\n  border: 1px solid #dee4f0;\n  background: #fff;\n  font-family: inherit;\n  font-size: 13px;\n  color: #5f7484;\n  cursor: pointer;\n  transition: background 0.14s, border-color 0.14s, color 0.14s;\n  width: fit-content !important;\n}\n\n.incyia-gantt-chip:hover {\n  border-color: #8b99b4;\n  color: #0b1e2d;\n}\n\n.incyia-gantt-chip.is-on {\n  background: #e2f7f2;\n  border-color: transparent;\n  color: #0e8271;\n  font-weight: 600;\n}\n\n.incyia-gantt {\n  width: 100%;\n  border: 1px solid #dee4f0;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #fff;\n  box-shadow:\n    0 1px 2px rgba(15, 23, 42, 0.05),\n    0 10px 28px -20px rgba(0, 20, 109, 0.4);\n  box-sizing: border-box;\n}\n\n.incyia-gantt-scroll {\n  width: 100%;\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n\n.incyia-gantt-inner {\n  display: block;\n  width: 100%;\n  min-width: 100%;\n  box-sizing: border-box;\n}\n\n.incyia-gantt-row {\n  display: flex;\n  width: 100%;\n  min-width: 100%;\n  border-bottom: 1px solid #eaeff7;\n  box-sizing: border-box;\n}\n\n.incyia-gantt-row:last-child {\n  border-bottom: none;\n}\n\n.incyia-gantt-left {\n  width: 280px;\n  flex: 0 0 280px;\n  padding: 16px 18px;\n  border-right: 1px solid #dee4f0;\n  position: sticky;\n  left: 0;\n  background: #fff;\n  z-index: 2;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 56px;\n}\n\n.incyia-gantt-row.is-head .incyia-gantt-left {\n  background: #f7f9fd;\n  min-height: 64px;\n}\n\n.incyia-gantt-left b {\n  font-size: 14px;\n  font-weight: 600;\n  display: block;\n  color: #0b1e2d;\n}\n\n.incyia-gantt-left span {\n  font-family: 'IBM Plex Mono', ui-monospace, monospace;\n  font-size: 11.5px;\n  color: #5f7484;\n  display: block;\n  margin-top: 3px;\n}\n\n.incyia-gantt-track {\n  position: relative;\n  display: flex;\n  flex: 1 1 auto;\n  min-width: 0;\n  width: auto;\n}\n\n.incyia-gantt-track.is-header {\n  display: flex;\n  flex-direction: column;\n  background: #f7f9fd;\n  min-width: 0;\n}\n\n.incyia-gantt-month {\n  display: flex;\n  width: 100%;\n  flex: none;\n}\n\n.incyia-gantt-m {\n  padding: 8px 10px;\n  font-weight: 700;\n  font-size: 11px;\n  letter-spacing: 0.13em;\n  text-transform: uppercase;\n  color: #5f7484;\n  border-right: 1px solid #dee4f0;\n  background: #f7f9fd;\n  flex: none;\n  box-sizing: border-box;\n  text-align: left;\n}\n\n.incyia-gantt-days {\n  display: flex;\n  width: 100%;\n  flex: 1;\n  min-height: 40px;\n}\n\n.incyia-gantt-day {\n  flex: 1 0 0;\n  min-width: 40px;\n  border-right: 1px solid #eaeff7;\n  text-align: center;\n  padding: 8px 0;\n  font-family: 'IBM Plex Mono', ui-monospace, monospace;\n  font-size: 10px;\n  color: #8b99b4;\n  box-sizing: border-box;\n}\n\n.incyia-gantt-day.is-we {\n  background: #f7f9fd;\n}\n\n.incyia-gantt-day.is-week {\n  min-width: 64px;\n}\n\n.incyia-gantt-day b {\n  display: block;\n  font-size: 12px;\n  color: #5f7484;\n  font-weight: 600;\n}\n\n.incyia-gantt-bar {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  height: 28px;\n  border-radius: 7px;\n  display: flex;\n  align-items: center;\n  padding: 0 12px;\n  font-size: 12.5px;\n  color: #fff;\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n  background: linear-gradient(90deg, #00146d, #1f3e9e);\n  box-shadow: 0 2px 8px -3px rgba(0, 20, 109, 0.6);\n  user-select: none;\n  touch-action: none;\n  box-sizing: border-box;\n}\n\n.incyia-gantt-bar.is-editable {\n  cursor: grab;\n  pointer-events: auto;\n}\n\n.incyia-gantt-bar.is-dragging {\n  cursor: grabbing;\n  opacity: 0.92;\n  z-index: 3;\n}\n\n.incyia-gantt-bar-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1;\n  min-width: 0;\n  pointer-events: none;\n}\n\n.incyia-gantt-handle {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 10px;\n  cursor: ew-resize;\n  z-index: 2;\n}\n\n.incyia-gantt-handle.is-start {\n  left: 0;\n}\n\n.incyia-gantt-handle.is-end {\n  right: 0;\n}\n\n.incyia-gantt-handle::after {\n  content: '';\n  position: absolute;\n  top: 6px;\n  bottom: 6px;\n  width: 2px;\n  border-radius: 1px;\n  background: rgba(255, 255, 255, 0.55);\n}\n\n.incyia-gantt-handle.is-start::after {\n  left: 4px;\n}\n\n.incyia-gantt-handle.is-end::after {\n  right: 4px;\n}\n\n@media (max-width: 900px) {\n  .incyia-gantt-left {\n    width: 200px;\n    flex-basis: 200px;\n  }\n}\n\n@media (max-width: 760px) {\n  .incyia-gantt-left {\n    width: 160px;\n    flex-basis: 160px;\n    padding: 12px 12px;\n  }\n\n  .incyia-gantt-day {\n    min-width: 32px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
